import { Injectable } from '@angular/core';

import { Router, } from '@angular/router';
import { CurrentUser } from 'app/model/current-user';
import { environment } from 'environments/environment';
import * as _ from 'underscore';
@Injectable({
    providedIn:'root'
})
export class PermissionService {
    claims: CurrentUser;
    constructor() {

    }

    hasPermission(...permittedRoles: string[]): boolean {

        this.claims = !!sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
        const roles = [];
        if (!!this.claims) {
            _.map(this.claims.roles, role => {
                roles.push(role.name);
                return role;
            });
            const isRoleContains = [];
            _.map(permittedRoles, role => {
                isRoleContains.push(_.contains(roles, role));
                return role;
            });
            return _.contains(_.uniq(isRoleContains), true);
        } else {
            return false;
        }
    }
    hasToken() {

        return !!sessionStorage.getItem('CURRENT_USER') ? true : false;

    }

    hasSetUp() {
        return environment.apiUrl.includes('unknown') ? true : false;
    }

}
